module.exports = __webpack_public_path__ + "static/media/mystino_blackjack.onetouch.07de47c6.jpeg";